import { LocalStorageKey } from '../helpers/types';

interface ReturnLocalStorage {
  jwt: string;
  setStorageValue(value: string): void;
  clearJwtKey(): void;
  // setStorageUserId(value: string): void;
}

export const useLocalStorage = (): ReturnLocalStorage => {
  const storedValue = JSON.parse(window.localStorage.getItem(LocalStorageKey.JWT) as string);

  const setStorageValue = (value: string) => {
    // console.log(value)
    window.localStorage.setItem(LocalStorageKey.JWT, JSON.stringify(value));
  };

  // const setStorageUserId = (value: string) => {
  //   window.localStorage.setItem(localStorage);
  // };

  const clearJwtKey = () => {
    window.localStorage.removeItem(LocalStorageKey.JWT);
  };

  // console.log('storedValue', storedValue);
  return {
    jwt: storedValue,
    setStorageValue,
    clearJwtKey,
    // setStorageUserId,
  };
};
